import React from "react";
import { ImagePlacementTask } from "data-models/task-models";
import ImagePlacementItem from "./ImagePlacementItem";
import { Center, SimpleGrid, useMediaQuery, VStack, Box } from "@chakra-ui/react";
import { useFollowUp } from "providers/FollowUpProvider";
import { useTranslation } from "react-i18next";
import { apiBase } from "services/config";
export default function ImagePlacementItems() {
  const { currentTask } = useFollowUp();
  const task = currentTask as ImagePlacementTask;
  const { i18n } = useTranslation();
  const [isSmallScreen] = useMediaQuery("(max-height: 900px)");

  const ActivitiesWithTwoGrids = ["8f3a6b74-2c91-4e7f-9a1d-6e5b0c2f9d43"];
  const ActivityIdsWithAudio = ["8f3a6b74-2c91-4e7f-9a1d-6e5b0c2f9d43"];
  const [activeAudioKey, setActiveAudioKey] = React.useState<string | null>(null);
  const currentAudioRef = React.useRef<HTMLAudioElement | null>(null);

  const getSoundUrl = (soundUrls?: string[]) => {
    const soundUrl = i18n.language === "se" ? soundUrls?.[0] : i18n.language === "de" ? soundUrls?.[2] : soundUrls?.[1];
    return soundUrl ? apiBase + soundUrl : "";
  };

  const playSound = (soundUrl: string, audioKey: string) => {
    if (!soundUrl) return;

    if (currentAudioRef.current) {
      currentAudioRef.current.pause();
      currentAudioRef.current.currentTime = 0;
    }

    const audio = new Audio(soundUrl);
    currentAudioRef.current = audio;
    audio.play();
    setActiveAudioKey(audioKey);
    audio.onended = () => {
      setActiveAudioKey(currentKey => {
        if (currentKey === audioKey) return null;
        return currentKey;
      });
      if (currentAudioRef.current === audio) {
        currentAudioRef.current = null;
      }
    };
  };

  React.useEffect(() => {
    return () => {
      if (currentAudioRef.current) {
        currentAudioRef.current.pause();
        currentAudioRef.current.currentTime = 0;
      }
    };
  }, []);

  return (
    <SimpleGrid
      columns={ActivitiesWithTwoGrids.includes(task.id) ? 2 : 3}
      pr="0"
      spacing="10px"
      className="hello"
      pl="10"
    >
      {task.answerOptions
        .filter(ao => !ao.placedAtPoint)
        .map(ao => {
          const soundUrl = getSoundUrl(ao.soundUrl);
          const isAudioEnabled = ActivityIdsWithAudio.includes(task.id) && !!soundUrl;
          const isActive = activeAudioKey === ao.imageUrl;

          return (
            <VStack key={ao.imageUrl} spacing="10px" mr="10">
              <Center bgColor="white" boxSize={isSmallScreen ? "90px" : "100px"} borderRadius="2xl">
                <ImagePlacementItem ipa={ao} />
              </Center>

              {isAudioEnabled && (
                <Box
                  as="button"
                  type="button"
                  className={`soundIcon ${isActive ? "animateAudioIcon" : ""}`}
                  onClick={() => playSound(soundUrl, ao.imageUrl)}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="25px"
                  height="25px"
                  borderRadius="50%"
                  overflow="hidden"
                  background={isActive ? "white" : "#2a0f74"}
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="1.5"
                    stroke={isActive ? "black" : "currentColor"}
                    width="15"
                    height="15"
                    color="black"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
                    />
                  </svg>
                </Box>
              )}
            </VStack>
          );
        })}
    </SimpleGrid>
  );
}
